module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "panel--bottom"
  }, [_c('h3', [_vm._v("Today - "), _c('span', [_vm._v(_vm._s(_vm.todaytime))])]), _vm._v(" "), _c('today-chart', {
    attrs: {
      "chart-data": _vm.datasetsfull,
      "height": 280,
      "options": {
        responsive: false,
        maintainAspectRatio: false
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "users--table"
  }, [_c('p', {
    staticClass: "text-left m-b-md"
  }, [_vm._v("Your daily reports")]), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryreports), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-content--header"
  }, [_c('h4', [_vm._v("Reports")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Date")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50148212"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports.vue
// module id = 385
// module chunks = 1